/* ====================================================================
   Oduree - Trustpilot-widgets in de taal van de pagina (oduree.com)
   ====================================================================
   De Trustpilot-blokken uit de thema-editor (app-blokken van Trustpilot)
   hebben een vaste taal, en die staat op Nederlands. Per taal instellen
   kan daar niet. Buiten het Nederlands zetten we de taal van elk widget
   daarom op de taal van de pagina (<html lang>): /de wordt de-DE, /fr
   wordt fr-FR enzovoort. Een taal die Trustpilot niet kent (Arabisch),
   wordt Brits Engels. Staat er toch een Nederlands widget (Trustpilot
   was ons voor), dan laden we dat widget opnieuw.

   Laden: alleen buiten de Nederlandse taal, vanuit layout/theme.liquid.
   De eigen sectie trustpilot-trustbox regelt de taal zelf al in Liquid.
   ==================================================================== */
(function () {
  "use strict";

  if (window.OdureeTrustpilotEn) return;
  window.OdureeTrustpilotEn = true;

  // Vangnet naast de voorwaarde in theme.liquid: nooit op de Nederlandse winkel.
  if (/^nl\b/i.test(document.documentElement.lang || "")) return;

  /* Trustpilot-taal per paginataal: alleen talen die Trustpilot zelf kent (TrustBox-locales).
     Ontbreekt de taal hier, dan Brits Engels. */
  var TRUSTPILOT_TAAL = {
    en: "en-GB", de: "de-DE", fr: "fr-FR", es: "es-ES", it: "it-IT", pt: "pt-PT",
    pl: "pl-PL", sv: "sv-SE", da: "da-DK", nb: "nb-NO", no: "nb-NO", fi: "fi-FI"
  };
  var paginaTaal = (document.documentElement.lang || "en").toLowerCase().split("-")[0];
  var TAAL = TRUSTPILOT_TAAL[paginaTaal] || "en-GB";
  var MERK = "data-oduree-taal";   // widgets waarvan wij de taal hebben gezet
  var TELLER = "data-oduree-herladen";
  var MAX_HERLADEN = 3;            // nooit blijven proberen

  function isNederlands(kader) {
    return /[#?&]locale=nl/i.test(kader.getAttribute("src") || "");
  }

  function herlaad(el) {
    if (!window.Trustpilot || !window.Trustpilot.loadFromElement) return;
    var keer = Number(el.getAttribute(TELLER) || 0);
    if (keer >= MAX_HERLADEN) return;
    el.setAttribute(TELLER, String(keer + 1));
    var kaders = el.querySelectorAll("iframe");
    for (var i = 0; i < kaders.length; i++) kaders[i].parentNode.removeChild(kaders[i]);
    window.Trustpilot.loadFromElement(el, true);
  }

  function zet(el) {
    if (/^nl/i.test(el.getAttribute("data-locale") || "")) {
      el.setAttribute("data-locale", TAAL);
      el.setAttribute(MERK, TAAL.split("-")[0]);
    }
    if (!el.hasAttribute(MERK)) return; // niet van ons: met rust laten
    // Trustpilot kan de Nederlandse taal al gelezen hebben voordat wij hem omzetten:
    // dan komt er alsnog een Nederlands widget. Dat herkennen we aan het adres.
    var kaders = el.querySelectorAll("iframe");
    for (var i = 0; i < kaders.length; i++) {
      if (isNederlands(kaders[i])) { herlaad(el); return; }
    }
  }

  var gevolgd = window.WeakSet ? new WeakSet() : null;

  function volg(el) {
    if (!gevolgd || !window.MutationObserver || gevolgd.has(el)) return;
    gevolgd.add(el);
    // Komt het widget er later in, dan kijken we opnieuw (na het zetten van het adres).
    new MutationObserver(function () { setTimeout(function () { zet(el); }, 0); })
      .observe(el, { childList: true, subtree: true });
  }

  function loop() {
    var lijst = document.querySelectorAll(".trustpilot-widget[data-locale]");
    for (var i = 0; i < lijst.length; i++) { zet(lijst[i]); volg(lijst[i]); }
  }

  loop(); // het script laadt met defer: de widgets staan al in de pagina
  document.addEventListener("DOMContentLoaded", loop);
  window.addEventListener("load", loop);
  // Sectie opnieuw geladen (thema-editor): opnieuw nalopen.
  document.addEventListener("shopify:section:load", loop);
})();
